





import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CountdownTimer extends Vue {
  timer: any
  value: number = 0

  destroyed () {
    this.clear()
  }

  clear () {
    clearInterval(this.timer)
  }

  start (duration: number = 60) {
    this.clear()

    this.value = duration
    this.timer = setInterval(this.tick, 1000)
  }

  tick () {
    if (!this.value) {
      this.clear()
      this.$emit('finish')

      return
    }

    this.value--
  }
}
